import React from 'react';
// ⚠️ 两个 import 路径前缀不同！不要从上一行复制前缀！
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataZz from './phonics/phonics_data_zz';

function PhonicsZz() {
  return <PhonicsAtoZ letterData={letterDataZz} />;
}

export default PhonicsZz;
